import { LoadingIndicator } from 'app/components/LoadingIndicator';
import * as React from 'react';
import { lazyLoad } from 'utils/loadable';

export const ServiceRequestHome = lazyLoad(
  () => import('./routes'),
  module => module.default,
  {
    fallback: <LoadingIndicator />,
  },
);
